import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded'
import FolderRoundedIcon from '@mui/icons-material/FolderRounded'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import { CardActionArea, CardActions } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Skeleton from '@mui/material/Skeleton'
import { alpha } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { ModalTypes } from 'common/hooks/useCustomModal'
import { useContext, useEffect, useState } from 'react'
import { puedeConsultar, puedeInsertar } from '../libs/PermisosHelper'
import { ExpedientesContext } from '../providers/ExpedientesProvider'
import ListadoExpedientes from './ListadoExpedientes'

export default function MenuExpedientes() {
  const { handleModal } = useContext(CustomModalContext)
  const {
    tipos_expedientes,
    active: { current, setCurrent, forceRefresh },
    setAltaExpediente,
    setOrigen,
  } = useContext(ExpedientesContext)

  const [tiposExpedienteMenu, setTiposExpedienteMenu] = useState()

  useEffect(() => {
    setOrigen('menuExpedientes')
  }, [])

  useEffect(() => {
    handleModal({ enabled: tipos_expedientes?.loading, type: ModalTypes.Loading })
  }, [tipos_expedientes?.loading])

  function buildTree(menuItems) {
    const menuTiposMap = {}
    const tree = []
    menuItems.forEach((item) => {
      menuTiposMap[item.tipo_expediente] = { ...item }
    })

    menuItems.forEach((item) => {
      tree.push(menuTiposMap[item.tipo_expediente])
    })

    return tree
  }

  useEffect(() => {
    if (!tipos_expedientes.response) return
    setTiposExpedienteMenu(buildTree(tipos_expedientes.response?.expedientes))
  }, [tipos_expedientes.response])

  const handleClick = (e) => {
    const menuItem = e.currentTarget.dataset.menuItem
    const tipo_expediente = tiposExpedienteMenu[menuItem]

    if (puedeConsultar(tipo_expediente)) {
      setCurrent(tipo_expediente)
      forceRefresh()
    }
  }

  const handleNuevoExpediente = (e) => {
    const menuItem = e.currentTarget.dataset.menuItem
    const tipo_expediente = tiposExpedienteMenu[menuItem]

    setCurrent(tipo_expediente)
    setAltaExpediente(true)
  }

  return (
    <Box key="expedientes" sx={{ flexGrow: 1 }}>
      {current ? (
        <ListadoExpedientes></ListadoExpedientes>
      ) : !tipos_expedientes?.loading ? (
        <Grid container spacing={2}>
          {tiposExpedienteMenu?.map((item, id) => {
            return (
              <Grid key={id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                <Card
                  elevation={0}
                  sx={(theme) => ({
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 4,
                    border: '1px solid transparent',
                    backgroundColor: alpha(theme.palette.primary.main, 0.05),
                    transition: theme.transitions.create(
                      ['transform', 'box-shadow', 'background-color'],
                      { duration: theme.transitions.duration.shorter },
                    ),
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 6,
                      backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    },
                  })}
                >
                  <CardActionArea
                    data-menu-item={id}
                    onClick={handleClick}
                    sx={{
                      flexGrow: 1,
                      p: 2.5,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'stretch',
                      gap: 1.5,
                    }}
                  >
                    <Box
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: 2,
                        display: 'grid',
                        placeItems: 'center',
                        color: 'primary.contrastText',
                        backgroundColor: 'primary.main',
                      }}
                    >
                      <FolderRoundedIcon />
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 600, lineHeight: 1.3, color: 'text.primary' }}
                    >
                      {item.nombre}
                    </Typography>
                  </CardActionArea>
                  <CardActions sx={{ justifyContent: 'flex-end', px: 2, pb: 2 }}>
                    {puedeConsultar(item) && (
                      <Button
                        startIcon={<FormatListBulletedIcon color="info" />}
                        data-menu-item={id}
                        onClick={handleClick}
                        sx={{ fontWeight: 600 }}
                      >
                        Consultar
                      </Button>
                    )}
                    {puedeInsertar(item) && (
                      <Button
                        startIcon={<AddCircleRoundedIcon color="warning" />}
                        data-menu-item={id}
                        onClick={handleNuevoExpediente}
                        sx={{ fontWeight: 600 }}
                      >
                        Nuevo
                      </Button>
                    )}
                  </CardActions>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      ) : (
        <Grid container spacing={2}>
          {[...Array(12).keys()].map((id, index) => {
            return (
              <Grid key={index} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                <Skeleton variant="rounded" height={150} sx={{ borderRadius: 4 }} />
              </Grid>
            )
          })}
        </Grid>
      )}
    </Box>
  )
}
